import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import './assets/css/index.scss';

createApp(App).use(router).mount('#app')
